import 'slick-carousel'
import 'jquery'
import { EventEmitter } from 'eventemitter3'
import Timer from '@/core/util/Timer'
import MathUtil from '@/core/util/MathUtil'

class GalleryCarouselController extends EventEmitter {
  private galleryCarouselDom: Element
  /**
   * コンストラクタ
   *
   */
  constructor(galleryCarouselDom: Element) {
    super()
    this.galleryCarouselDom = galleryCarouselDom
  }

  public async init(): Promise<void> {
    const carousel = this.galleryCarouselDom.getElementsByClassName(
      'carousel',
    )[0]

    //開始位置をランダムにする
    let carouselItems = carousel.querySelectorAll('.carouselItem')
    const startIndex = MathUtil.getRandomArbitrary(0, carouselItems.length - 1)
    console.log(startIndex)
    for (let i = 0; i < startIndex; i++) {
      carousel.appendChild(carouselItems[i])
    }

    // カルーセル
    $(carousel).slick({
      infinite: true,
      // 自動再生
      autoplay: true,
      // ドット表示
      dots: false,
      // 中心表示
      // centerMode: true,
      variableWidth: true,
      // アニメーション
      autoplaySpeed: 0,
      slidesToShow: 1,
      cssEase: 'linear',
      speed: 6000,
      // 画面に表示させるパネル数
      // slidesToShow: 3,
      // slidesToScroll: 2,
      responsive: [],
    })

    //
    this.galleryCarouselDom.classList.add('is-show')

    //
    carouselItems = carousel.querySelectorAll('.carouselItem')
    for (let i = 0; i < carouselItems.length; i++) {
      await Timer.wait(i == 0 ? 1 : 150)
      carouselItems[i].classList.add('is-show')
    }
  }

  public async init2(): Promise<void> {
    const carousel = this.galleryCarouselDom.getElementsByClassName(
      'carousel',
    )[0]

    // カルーセル
    $(carousel).slick({
      // 自動再生
      autoplay: true,
      // ドット表示
      dots: false,
      // 中心表示
      centerMode: true,
      // アニメーション
      autoplaySpeed: 0,
      cssEase: 'linear',
      speed: 8000,
      // 画面に表示させるパネル数
      slidesToShow: 3,
      // slidesToScroll: 2,
    })

    //
    // this.galleryCarouselDom.classList.add('is-show')

    //
    const carouselItems = carousel.querySelectorAll('.carouselItem')
    for (let i = 0; i < carouselItems.length; i++) {
      await Timer.wait(i == 0 ? 1 : 150)
      carouselItems[i].classList.add('is-show')
    }
  }
}

export default GalleryCarouselController
